// src/hooks/useFnct.ts — SCE Issues
// Les FNC-T et leurs actions (cache de session de fnct.api) — chantier FNC-T.
// Une erreur est TOUJOURS renvoyée : une liste vide ne doit jamais déguiser un
// échec de chargement (liste introuvable, colonne manquante, droits).

import { useCallback, useEffect, useState } from 'react'
import { chargerFnct, oublierListesFnct, type DonneesFnct } from '@/api/fnct.api'

export interface EtatFnct extends DonneesFnct {
  loading: boolean
  error: string | null
  /** Relit les deux listes (après un import, par exemple). */
  recharger: () => void
}

export function useFnct(): EtatFnct {
  const [donnees, setDonnees] = useState<DonneesFnct>({ fncts: [], actions: [] })
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const [version, setVersion] = useState(0)

  useEffect(() => {
    let annule = false
    setLoading(true)
    setError(null)
    chargerFnct()
      .then((d) => {
        if (!annule) setDonnees(d)
      })
      .catch((err: unknown) => {
        if (!annule) setError(err instanceof Error ? err.message : 'Chargement des FNC-T impossible')
      })
      .finally(() => {
        if (!annule) setLoading(false)
      })
    return () => {
      annule = true
    }
  }, [version])

  const recharger = useCallback(() => {
    oublierListesFnct()
    setVersion((v) => v + 1)
  }, [])

  return { ...donnees, loading, error, recharger }
}
